// ========================================
// COMPONENTE FOLDERSVIEW (VISTA DE CARPETAS)
// Muestra la lista de carpetas del usuario en formato grid
// ========================================

import React from 'react';

// Componente que recibe:
// - folders: array de carpetas del usuario
// - loading: estado de carga
// - onFolderSelect: función para seleccionar una carpeta
// - onDeleteFolder: función para eliminar una carpeta
// - onRenameFolder: función para renombrar una carpeta
const FoldersView = ({ folders, loading, onFolderSelect, onDeleteFolder, onRenameFolder, onOpenSettings, hideEmptyState }) => {

    // spinner mientras se cargan las carpetas
    if (loading) {
        return (
            <div className="loading-spinner">
                Cargando carpetas...
            </div>
        );
    }

    // Sin subcarpetas: si estamos dentro de una carpeta (hideEmptyState), no mostrar nada
    // (los archivos se muestran aparte). En la raíz, mostrar mensaje de bienvenida.
    if (folders.length === 0) {
        if (hideEmptyState) return null;
        return (
            <div className="empty-state">
                <div className="empty-state-icon">📁</div>
                <div className="empty-state-text">
                    No tienes carpetas aún. Crea tu primera carpeta para comenzar.
                </div>
            </div>
        );
    }

    // Renderizar grid de carpetas
    return (
        <div className="folders-grid">
            {folders.map((folder) => (
                <div key={folder.idCarpeta} className="folder-item">
                    {/* Contenido principal de la carpeta (clickeable) */}
                    <div
                        className="folder-content"
                        onClick={() => onFolderSelect(folder)}  // Al hacer click, seleccionar carpeta
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="folder-icon">
                            {folder.fileCount > 0 ? '📁' : '📂'}  {/* Carpeta llena vs vacía */}
                        </div>
                        <div className="folder-name">{folder.nombreCarpeta}</div>
                        <div className="folder-info">
                            {folder.fileCount === 0 ? 'Vacía' :
                                folder.fileCount === 1 ? '1 archivo' :
                                    `${folder.fileCount} archivos`}
                        </div>
                    </div>

                    {/* Botones de acción: solo para quien gestiona la carpeta (creador o admin) */}
                    {folder.puedeGestionar ? (
                        <div className="folder-actions">
                            <button
                                className="btn btn-secondary"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onRenameFolder(folder);
                                }}
                            >
                                Renombrar
                            </button>
                            <button
                                className="btn btn-info"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onOpenSettings && onOpenSettings(folder);
                                }}
                            >
                                Compartir
                            </button>
                            <button
                                className="btn btn-danger"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDeleteFolder(folder.idCarpeta);
                                }}
                            >
                                Eliminar
                            </button>
                        </div>
                    ) : (
                        <div className="folder-actions">
                            <span className="folder-shared-badge">
                                Compartida contigo
                            </span>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default FoldersView;
